
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Sparkles, 
  Users, 
  Rocket, 
  ArrowRight
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const RecommendationSection: React.FC = () => {
  return (
    <Card className="neo-card overflow-hidden border border-neon-purple/20 shadow-lg bg-white/5 h-full">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-neon-purple" />
          We Recommend
        </CardTitle>
        <CardDescription>Personalized for your artist journey</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {/* Recommendation Card 1 */}
        <div className="p-3 rounded-lg border border-neon-purple/20 bg-black/40 hover:bg-black/60 transition-colors group">
          <div className="flex items-start gap-3">
            <div className="h-10 w-10 rounded-full bg-neon-purple/20 flex items-center justify-center">
              <Users className="h-5 w-5 text-neon-purple" />
            </div>
            <div className="flex-1">
              <h3 className="font-medium group-hover:text-neon-purple transition-colors">Find New Collaborators</h3>
              <p className="text-sm text-gray-400 mt-0.5">Find musicians that match your style</p>
            </div>
          </div>
          <div className="mt-2 flex justify-end">
            <Button variant="ghost" size="sm" className="text-neon-purple h-7 px-2" asChild>
              <Link to="/match" className="flex items-center gap-1">
                <span>Connect</span>
                <ArrowRight className="h-3 w-3" />
              </Link>
            </Button>
          </div>
        </div>
        
        {/* Recommendation Card 2 */}
        <div className="p-3 rounded-lg border border-neon-blue/20 bg-black/40 hover:bg-black/60 transition-colors group">
          <div className="flex items-start gap-3">
            <div className="h-10 w-10 rounded-full bg-neon-blue/20 flex items-center justify-center">
              <Rocket className="h-5 w-5 text-neon-blue" />
            </div>
            <div className="flex-1">
              <h3 className="font-medium group-hover:text-neon-blue transition-colors">Boost Engagement</h3>
              <p className="text-sm text-gray-400 mt-0.5">Improve your online presence</p>
            </div>
          </div>
          <div className="mt-2 flex justify-end">
            <Button variant="ghost" size="sm" className="text-neon-blue h-7 px-2" asChild>
              <Link to="/artist-health" className="flex items-center gap-1">
                <span>View Tips</span>
                <ArrowRight className="h-3 w-3" />
              </Link>
            </Button>
          </div>
        </div>
        
        {/* More Recommendations Button */}
        <Button variant="outline" size="sm" className="w-full border-neon-purple/30 text-neon-purple hover:bg-neon-purple/10 mt-1" asChild>
          <Link to="/recommendations" className="flex items-center justify-center gap-1">
            More Recommendations
            <ArrowRight className="h-3 w-3" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};

export default RecommendationSection;
